import JsFunction from './JsFunction';

export default class DatePickerMethod extends JsFunction {
  constructor(method) {
    super(method);
    this.inputDataTemplate = method.inputDataTemplate;
    this.compId = method.compId;
  }

  printFunction() {
    super.clearfunctionNextTemplate();
    this.functionality += this.createDatePickerMethodFunctionality();
    return this.functionality;
  }

  createDatePickerMethodFunctionality() {
    const functionality = `$(
      function () { $("#${this.compId}").datepicker({format: 'dd-mm-yyyy'}); }
    );`;
    return functionality;
  }
}
